<template>
  <div class="menu-item" @click="toggleMenu" @mouseleave="closeMenu">
    <a href="#">
      {{ title }}
    </a>
    <svg viewBox="0 0 1030 638" width="10">
      <path
        d="M1017 68L541 626q-11 12-26 12t-26-12L13 68Q-3 49 6 24.5T39 0h952q24 0 33 24.5t-7 43.5z"
        fill="#FFF"
      ></path>
    </svg>
    <transition name="fade" appear>
      <!-- MODIF: Adicionado ref ao submenu para ajuste de posição -->
      <div class="sub-menu" v-if="isOpen" ref="submenu">
        <!-- MODIF: Alterado para que o div inteiro seja clicável usando router-link custom -->
        <router-link to="/dados/Acumulados" custom v-slot="{ navigate, isActive }">
          <div @click="navigate" :class="['menu-item', 'nav-item', 'nav-link', { active: isActive }]" id="acumulados">
            Acumulados
          </div>
        </router-link>
        <router-link to="/dados/consultarDadosRecentes" custom v-slot="{ navigate, isActive }">
          <div @click="navigate" :class="['menu-item', 'nav-item', 'nav-link', { active: isActive }]" id="consultarDadosRecentes">
            Dados Recentes
          </div>
        </router-link>
        <router-link to="/dados/agendarConsultaDadosHistoricos" custom v-slot="{ navigate, isActive }">
          <div @click="navigate" :class="['menu-item', 'nav-item', 'nav-link', { active: isActive }]" id="agendarDadosHistoricos">
            Dados Históricos
          </div>
        </router-link>
        <router-link to="/ConsultarRedeEstacoes" custom v-slot="{ navigate, isActive }">
          <div @click="navigate" :class="['menu-item', 'nav-item', 'nav-link', { active: isActive }]" id="consultarRedeEstacoes">
            Informações das Estações
          </div>
        </router-link>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "services",
  props: ["title"],
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    toggleMenu() {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        this.$nextTick(() => {
          this.adjustSubmenuPosition();
        });
      }
    },
    closeMenu() {
      this.isOpen = false;
    },
    adjustSubmenuPosition() {
      const submenu = this.$refs.submenu;
      if (submenu) {
        const rect = submenu.getBoundingClientRect();
        if (rect.right > window.innerWidth) {
          submenu.style.left = "auto";
          submenu.style.right = "0";
          submenu.style.transform = "none"; // MODIF: Ajustado para caber na tela
        } else if (rect.left < 0) {
          submenu.style.left = "0";
          submenu.style.transform = "none"; // MODIF: Ajustado para caber na tela
        } else {
          submenu.style.left = "50%";
          submenu.style.right = "auto";
          submenu.style.transform = "translateX(-50%)";
        }
      }
    },
  },
};
</script>

<style>
nav .menu-item svg {
  width: 10px;
  margin-left: 10px;
}
nav .menu-item .sub-menu {
  position: absolute;
  background-color: #3276b1; /* MODIF: Fundo opaco garantido */
  top: calc(100% + 5px);
  left: 50%;
  transform: translateX(-50%);
  width: max-content;
  border-radius: 0px 0px 16px 16px;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s ease-out;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.sub-menu {
  cursor: pointer;
}
</style>

